<template>
  <div class="pb-14">
    <div class="">
      <div class="relative">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300" />
        </div>
        <div class="relative flex justify-between items-center">
          <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">
            Upcoming public session within my organisation{{ !isStudent ? 's' : '' }}
          </span>
          <div class="bg-light-grey pl-3">
            <select
              @change="filterByClinician"
              class="
                mt-1
                block
                w-full
                pl-3
                pr-10
                py-2
                text-base
                border-gray-300
                focus:outline-none
                focus:ring-indigo-500
                focus:border-indigo-500
                sm:text-sm
                rounded-md
              "
              :class="{ 'opacity-50 pointer-events-none': !this.upcoming_sessions.length }"
            >
              <option>Filter by clinician</option>
              <option
                v-for="clinician in clinician_list"
                :value="clinician?.id"
                :key="clinician?.id"
              >
                {{ clinician?.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex flex-col mt-8" v-if="this.upcoming_sessions.length">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="
                        pl-6
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        tracking-wider
                      "
                    >
                      Title
                    </th>
                    <th
                      scope="col"
                      class="
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        tracking-wider
                      "
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      class="
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        tracking-wider
                      "
                    >
                      Time
                    </th>
                    <th
                      scope="col"
                      class="
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        tracking-wider
                      "
                    >
                      Clinician
                    </th>
                    <th
                      scope="col"
                      class="
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        whitespace-nowrap
                        tracking-wider
                      "
                    >
                      Year of Study
                    </th>
                    <th
                      scope="col"
                      class="
                        py-3
                        text-left text-xxs
                        font-medium
                        text-gray-500
                        uppercase
                        tracking-wider
                      "
                    >
                      OPEN PLACES
                    </th>
                    <th scope="col" class="relative py-3">
                      <span class="sr-only">Labels</span>
                    </th>
                    <th scope="col" class="relative py-3">
                      <span class="sr-only">Action</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(session, sessionIdx) in this.upcoming_sessions"
                    :key="session.unique_id"
                    :class="{
                      'cursor-pointer': isStudent,
                      'bg-white': sessionIdx % 2 === 0,
                      'bg-gray-50': sessionIdx % 2 === 1,
                    }"
                    @click="handleDetailsClick(session.unique_id)"
                  >
                    <td class="pl-6 pr-2 py-4 text-xs max-w-lg font-medium text-vice-teal-900">
                      {{ session.title }}
                    </td>
                    <td class="py-4 whitespace-nowrap text-xs text-gray-500">
                      {{ yearFormatter(session.details.session_start_by_timezone) }}
                    </td>
                    <td class="py-4 whitespace-nowrap text-xs pr-2 text-gray-500">
                      {{ hoursFormatter(session.details.session_start_by_timezone) }}
                    </td>
                    <td class="py-4 whitespace-nowrap text-xs text-gray-500">
                      {{ session.details.clinician?.name }}
                    </td>
                    <td class="py-4 whitespace-nowrap text-xs text-gray-500">
                      {{ session.details.year_of_study }}
                    </td>
                    <td class="flex py-4 gap-4">
                      <ViceBadge
                        :amount="session.open_participant_position"
                        icon="UserIcon"
                        indigo
                      />

                      <ViceBadge :amount="session.open_observer_position" icon="EyeIcon" yellow />
                    </td>
                    <td>
                      <ViceBadge
                        purple
                        v-if="openPositionsIndicator(session) == openPositionsLabel.almostFull"
                      >
                        {{ openPositionsLabel.almostFull }}
                      </ViceBadge>
                      <ViceBadge
                        red
                        v-if="openPositionsIndicator(session) == openPositionsLabel.full"
                      >
                        {{ openPositionsLabel.full }}
                      </ViceBadge>
                      <ViceBadge
                        blue
                        v-if="openPositionsIndicator(session) == openPositionsLabel.private"
                      >
                        {{ openPositionsLabel.private }}
                      </ViceBadge>
                    </td>
                    <td class="" v-if="isStudent">
                      <a
                        :href="route('session.user.details', session.unique_id)"
                        class="text-gray-500 hover:text-gray-400"
                      >
                        <ChevronRightIcon class="h-4 w-4 align-middle"></ChevronRightIcon>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-8 text-gray-500 flex items-center justify-center text-center"
        v-if="!this.upcoming_sessions.length"
      >
        <span v-if="isStudent && !this.$page.props.user.university_id">
          You're not part of an organization and won't see any public sessions.
          <br />
          Please contact your organization administrator (not VCE) to add you to an organization.
        </span>
        <span v-else>There are no upcoming sessions.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/solid';
import openPositionsLabel from '@/Composables/Enums/openPositionsLabel';
import DateFormatMixin from '@/Mixins/DateFormatMixin.vue';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';

export default {
  name: 'UpcomingSessions',

  components: {
    ViceBadge,
    ChevronRightIcon,
  },
  mixins: [DateFormatMixin],

  setup() {
    const openPositionsIndicator = (session) => {
      if (session.is_private) {
        return session.private;
      }

      const openPositions = session.open_observer_position + session.open_participant_position;
      if (openPositions == 0) {
        return openPositionsLabel.full;
      }
      if (openPositions <= 3) {
        return openPositionsLabel.almostFull;
      }
      return false;
    };
    return {
      openPositionsLabel,
      openPositionsIndicator,
      userType,
    };
  },

  data() {
    return {
      clinician_list: [],
      isStudent: !this.$page.props.isClinician && !this.$page.props.isAdmin,
      upcoming_sessions: this.$page.props.sessions.upcoming_clinician_sessions,
    };
  },

  mounted() {
    this.setClinicianList();
  },

  methods: {
    filterByClinician(e) {
      if (e.target.options.selectedIndex >= 0) {
        const clinicianId = e.target.options[e.target.options.selectedIndex].value;
        this.upcoming_sessions = this.$page.props.sessions.upcoming_clinician_sessions;
        if (e.target.options.selectedIndex) {
          this.upcoming_sessions = this.upcoming_sessions.filter(
            (session) => session.details.clinician.id == clinicianId,
          );
        }
      }
    },

    setClinicianList() {
      if (this.$page.props.sessions.upcoming_clinician_sessions.length) {
        this.clinician_list = this.$page.props.sessions.upcoming_clinician_sessions
          .map((session) => ({
            id: session.details.clinician.id,
            name: session.details.clinician.name,
          }))
          .filter(
            (clinician, index, self) => index === self.findIndex((c) => c.id === clinician.id),
          );
      }
    },

    handleDetailsClick(uniqueId) {
      if (this.isStudent) {
        this.$inertia.get(route('session.user.details', uniqueId));
      }
    },
  },
};
</script>
